import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import DataTable from "../../../lib/components/DataTable";
import EmptyState from "../../../lib/components/EmptyState";
import pathnames from "../../../constants/pathnames";

const UsersDataTable = ({ data = [], isLoading, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  if (isLoading) return null;

  const columns = [
    {
      key: "name",
      header: "Name",
      render: (_, row) => (
        <Link to={`${pathnames.USERS}/${row?.id}`} className="fw-medium">
          {row?.firstName} {row?.lastName}
        </Link>
      ),
    },
    {
      key: "email",
      header: "Email",
    },
    {
      key: "phone",
      header: "Phone",
      render: (value) => {
        if (!value) return "N/A";
        return value.startsWith("+") ? value : `+${value}`;
      },
    },
    {
      key: "signupPlatform",
      header: "Sign-Up Platform",
      render: (_, row) => row?.tracking?.signup?.platform?.type || "N/A",
    },
    {
      key: "lastSignedIn",
      header: "Last Signed In",
      render: (_, row) => (
        <>
          {row?.tracking?.signin?.platform?.device || "N/A"}
          <br />
          {row?.tracking?.signin?.updatedAt ? moment(row.tracking.signin.updatedAt).format("YYYY-MM-DD LT") : "N/A"}
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <EmptyState isEmpty={!isLoading && !data.length} />
    </>
  );
};

export default UsersDataTable;
